"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInterfaceAdapter = void 0;

var web3_1 = require("./web3");

var getNetworkTypeClass = function getNetworkTypeClass() {
  var networkType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ethereum";
  var supportedEvmNetworks = ["ethereum", "fabric-evm", "quorum"];
  if (supportedEvmNetworks.includes(networkType)) return "evm-like";
  return networkType;
};

exports.createInterfaceAdapter = function (options) {
  var networkType = options.networkType;

  switch (getNetworkTypeClass(networkType)) {
    case "evm-like":
      {
        var provider = options.provider;
        return new web3_1.Web3InterfaceAdapter({
          networkType: networkType,
          provider: provider
        });
      }

    default:
      throw Error("Sorry, \"".concat(networkType, "\" is not supported at this time."));
  }
};